<template>
  <div>
    <v-row class="mb-4">
      <Breadcrump class="mb-2" :crumbs="crumbs" />
      <v-spacer></v-spacer>

      <v-btn
        @click="$router.go(-1)"
        class="mx-10 mt-5"
        fab
        small
        dark
        color="indigo"
      >
        <v-icon dark> mdi-arrow-left </v-icon>
      </v-btn>
    </v-row>

    <!-- فیلترهای جستجو و بازه تاریخی -->
    <v-container>
      <v-row>
        <!-- جستجوی متن -->
        <v-col cols="12" md="3">
          <v-text-field
            v-model="searchText"
            label="جستجو"
            placeholder="متن مورد نظر..."
            prepend-icon="mdi-magnify"
            clearable
            @click:clear="clearSearch()"
            @keyup.enter="applyFilters"
            solo
            dense
          />
        </v-col>

        <!-- تاریخ شروع -->
        <v-col cols="12" md="3">
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="startDateFormatted"
                label="از تاریخ"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                @click:clear="clearStartDate()"
                v-bind="attrs"
                v-on="on"
                solo
                dense
              />
            </template>
            <v-date-picker
              v-model="startDate"
              locale="fa"
              @input="
                menu1 = false;
                applyFilters();
              "
            />
          </v-menu>
        </v-col>

        <!-- تاریخ پایان -->
        <v-col cols="12" md="3">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="endDateFormatted"
                label="تا تاریخ"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                @click:clear="clearEndDate()"
                v-bind="attrs"
                v-on="on"
                solo
                dense
              />
            </template>
            <v-date-picker
              v-model="endDate"
              locale="fa"
              @input="
                menu2 = false;
                applyFilters();
              "
            />
          </v-menu>
        </v-col>

        <!-- دکمه‌ها -->
        <v-col cols="12" md="3" class="d-flex align-start">
          <v-btn color="primary" @click="applyFilters" :loading="loading">
            اعمال فیلتر
          </v-btn>
          <v-btn color="grey" @click="resetFilters" class="mr-2" outlined>
            بازنشانی
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-data-table
      :headers="headers"
      :items="logList"
      :loading="loading"
      hide-default-footer
      :server-items-length="totalLogs"
      item-key="id"
      class="elevation-1"
    >
    </v-data-table>

    <v-pagination
      v-model="options.page"
      @input="next"
      :length="pages"
      :total-visible="7"
    ></v-pagination>
  </div>
</template>

<script>
import request from "@/utils/request";
import Vue from "vue";
import Breadcrump from "@/components/common/Breadcrump.vue";
import moment from "moment-jalaali";

export default {
  name: "Devices",
  components: {
    Breadcrump
  },
  data() {
    return {
      crumbs: [
        {
          text: "خانه",
          disabled: false,
          href: "/"
        },
        {
          text: "لاگ کاربران",
          disabled: false,
          href: "/complexes"
        }
      ],
      // فیلدهای جدید برای فیلتر
      searchText: "",
      startDate: null,
      endDate: null,
      menu1: false,
      menu2: false,

      // نگهداری از ساختار قبلی options (بدون تغییر)
      selectedComplex: {},
      selectedUser: {},
      complexes: [],
      subComplexes: [],
      selectedComplexId: null,
      selectedSubComplexId: null,
      users: [],
      totalLogs: 0,
      pages: 0,
      name: null,
      logList: [],
      loading: true,

      options: {
        page: 1,
        itemsPerPage: 10,
        mustSort: true,
        sortDesc: [false]
      },

      headers: [
        { text: "شناسه", value: "id", sortable: false },
        { text: "تاریخ", value: "date", sortable: false },
        { text: "متن", value: "content", sortable: false }
      ]
    };
  },

  computed: {
    formattedDate: function() {
      let formattedDate = "";
      let options = {
        weekday: "short",
        year: "numeric",
        month: "2-digit",
        day: "numeric"
      };
      if (this.options.from) {
        formattedDate = new Date(this.options.from).toLocaleDateString(
          "fa",
          options
        );
      }
      return formattedDate;
    },
    formattedDate1: function() {
      let formattedDate = "";
      let options = {
        weekday: "short",
        year: "numeric",
        month: "2-digit",
        day: "numeric"
      };
      if (this.options.to) {
        formattedDate = new Date(this.options.to).toLocaleDateString(
          "fa",
          options
        );
      }
      return formattedDate;
    },
    // نمایش شمسی تاریخ‌ها
    startDateFormatted() {
      return this.startDate
        ? moment(this.startDate).format("jYYYY/jMM/jDD")
        : "";
    },
    endDateFormatted() {
      return this.endDate ? moment(this.endDate).format("jYYYY/jMM/jDD") : "";
    }
  },

  watch: {
    options: {
      handler(curr, prev) {
        const watchProps = ["page", "itemsPerPage", "sortBy", "sortDesc"];
        for (let i = 0; i < watchProps.length; i++) {
          const key = watchProps[i];
          if (prev[key] !== curr[key]) {
            return this.getLogs();
          }
        }
      },
      deep: true
    }
  },

  mounted() {
    this.getLogs();
  },

  methods: {
    // متدهای جدید برای پاک کردن فیلترها
    clearSearch() {
      this.searchText = "";
      this.applyFilters();
    },
    clearStartDate() {
      this.startDate = null;
      this.applyFilters();
    },
    clearEndDate() {
      this.endDate = null;
      this.applyFilters();
    },

    clearFrom() {
      this.options.from = null;
    },
    clearTo() {
      this.options.to = null;
    },
    next(page) {
      this.options.page = page;
      this.getLogs(); // این خط اضافه شده
    },
    handler(event) {
      this.options = event;
    },
    async getComplexes() {
      await request.get(`/publicData/main-complexes`).then(response => {
        var data = response.data.result;
        this.complexes = data;
      });
    },
    async getSubComplexes() {
      await request
        .get(`/publicData/sub-complexes/${this.selectedComplexId}`)
        .then(response => {
          var data = response.data.result;
          this.subComplexes = data;
          this.selectedSubComplexId = this.selectedComplexId;
          this.getDevices();
        });
    },
    async getDevices(name) {
      await request
        .get(`/publicData/main-complexes-devices/${this.selectedSubComplexId}`)
        .then(response => {
          var data = response.data.result;
          this.users = data;
        });
    },

    // توابع جدید برای فیلترها
    applyFilters() {
      this.options.page = 1;
      this.getLogs(); // این خط اضافه شده
    },
    resetFilters() {
      this.searchText = "";
      this.startDate = null;
      this.endDate = null;
      this.options.page = 1;
      this.getLogs(); // این خط اضافه شده
    },

    async getLogs() {
      const { sortDesc, sortBy, page, itemsPerPage } = this.options;
      this.loading = true;

      // ساخت query string از options موجود (دست نخورده)
      const optionQuery = Object.keys(this.options)
        .filter(x => this.options[x] !== null && this.options[x] !== undefined)
        .map(key => `${key}=${this.options[key]}`)
        .join("&");

      // افزودن فیلترهای جدید به صورت دستی
      const extraParams = [];
      if (this.searchText?.trim()) {
        extraParams.push(
          `SearchText=${encodeURIComponent(this.searchText.trim())}`
        );
      }
      if (this.startDate) {
        extraParams.push(`StartDate=${this.startDate}`);
      }
      if (this.endDate) {
        extraParams.push(`EndDate=${this.endDate}`);
      }

      const filterQuery = [optionQuery, ...extraParams]
        .filter(Boolean)
        .join("&");

      try {
        const response = await request.get(`/user/member-log?${filterQuery}`);
        const data = response.data.result;
        this.logList = data.result;
        this.totalLogs = data.totalItems;
        this.pages = data.pageCount;
      } catch (error) {
        console.error("خطا در دریافت لاگ‌ها:", error);
        this.logList = [];
        this.totalLogs = 0;
        this.pages = 0;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
